import { useSelector } from "react-redux";
import api from "../../storage/api";

const TopDonatorsModal = (props) => {
  const donatorsDescriptionImg = useSelector((state) => state.modals.data.topDonatorsDescriptionImg);

  return (
    <div className="modal-window modal-window_card-add">
      <div className="modal-controls-wrapper">
        <h5 className="modal-title">Что получают топ донатеры</h5>
        <button type="button" className="modal-close" onClick={props.closeHandler}></button>
      </div>
      <div className="modal-gray">
        <p className="card-add-description">Топ донатеры получают все предметы с изображения:</p>
        <img
          src={api.apiUrl + donatorsDescriptionImg}
          className="card-add-image-description no-margin"
          alt="Что получают топ донатеры"
        />
      </div>
    </div>
  );
};

export default TopDonatorsModal;
